

































































































































import { Component, Vue, Inject, Prop } from 'vue-property-decorator';
import store from '@/store';
import { Menu, MenuItem } from '@/router/menu';
import { AuthService } from '@/data/services/auth.service';
import { Headquarter } from '@/data/models/headquarter.model';
import Constants from '@/data/utils/constants';
import { LocalStorageManager } from '@/data/utils/local-storage';

@Component
export default class Sidebar extends Vue {
	@Prop() menu!: Menu[];
	@Inject('AuthService') authService!: AuthService;

	version = process.env.VERSION;

	get user() {
		return store.user;
	}

	get headquarters() {
		return store.headquarters;
	}

	get headquarter(): Headquarter | undefined {
		return store.headquarter;
	}

	set headquarter(value: Headquarter | undefined) {
		store.headquarter = value;
		LocalStorageManager.set(
			Constants.STORAGE_HEADQUARTER,
			value!.id.toString()
		);
	}

	getAclArg(item: MenuItem): string {
		return item.aclOr ? 'or' : '';
	}

	getAllChildrenAcl(item: Menu): string[] {
		let all: string[] = [];
		item.children.forEach((c) => {
			if (c.acl) {
				all = [...all, ...(Array.isArray(c.acl) ? c.acl : [c.acl])];
			}
		});
		return all;
	}

	getGroupAcl(item: MenuItem): string[] {
		if (!item.group) return [];
		let all: string[] = [];
		item.group.forEach((c) => {
			if (c.acl) {
				all = [...all, ...(Array.isArray(c.acl) ? c.acl : [c.acl])];
			}
		});
		return all;
	}

	logout() {
		this.$router.push('/login').then(() => {
			this.authService.logout();
			store.reset();
		});
	}
}
